import { useEffect } from 'react';
import { useLocation, useRouter } from '@tanstack/react-router';
import { useLayout } from '@portal/platform/configuration';
import { loginHref } from '@portal/platform/guards';
import { useSession } from '@portal/platform/session';
import { LegacyPage, NotFoundPage } from '@portal/ui';
import { APP_CONFIG } from '@/config';
import { isLegacyPath } from './legacy-path';
import { DealerShell } from './shell';

/**
 * Any address no route matched. Logged in: a page the backend navigation lists is one this app
 * has not ported yet, so link to it in the Angular portal; anything else is not found. Logged
 * out: log in first, then come back.
 */
export function NotFound() {
  const session = useSession();
  const location = useLocation();
  const router = useRouter();
  const layout = useLayout();
  const anonymous = session.status !== 'authenticated';

  useEffect(() => {
    if (anonymous) {
      void router.navigate({ href: loginHref(location) });
    }
  }, [anonymous, router, location]);

  if (anonymous) {
    return null;
  }
  return (
    <DealerShell>
      {layout.isPending ? null : isLegacyPath(location.pathname, layout.data) ? (
        <LegacyPage legacyBaseUrl={APP_CONFIG.LEGACY_PORTAL_URL} />
      ) : (
        <NotFoundPage />
      )}
    </DealerShell>
  );
}
